import styled, { keyframes } from 'styled-components';
import { grid } from '_/styles';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1;  }
`;

const heightAnimation = keyframes`
  from {max-height:0; }
  to {max-height:300px; }
`;

export const Container = styled.div`
  height: 184px;
  width: 864px;
  overflow: hidden;
  margin-top: ${grid.regular};
  animation: ${heightAnimation} 0.3s linear;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  animation: ${fadeIn} 1s linear;
`;
